/** True when the value is an https link to a Google Doc (docs.google.com/document/…). */
export function isPublicGoogleDocUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }
  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return false;
  }
  if (url.protocol !== 'https:' || url.username || url.password) {
    return false;
  }
  if (url.hostname !== 'docs.google.com') {
    return false;
  }
  return /^\/document\/(?:u\/\d+\/)?d\/(?:e\/)?[^/]+/i.test(url.pathname);
}
